
export default {
    name: 'LeeMenuTree',
    inheritAttrs: false,
    data() {
        return {
            exp: false
        }
    },
    watch: {

    },
    mounted() {

    },
    methods: {
        toggle(item) {
            if (item.child && item.child.length) {
                this.exp = !this.exp
            }
        },
        enter(el) {
            var h = el.scrollHeight
            el.style.setProperty('--h', h + 'px')
        },
        afterenter(el) {
            el.removeAttribute('style')
        },
        leave(el) {
            var h = el.scrollHeight
            el.style.setProperty('--h', h + 'px')
        },
        afterleave(el) {
            el.style.setProperty('--h', '')
        }
    },
    computed: {

    },
    props: {
        item: {
            type: Object,
            default () {
                return {}
            }
        }
    }
};
